import type { ErrorInfo, PropsWithChildren } from 'react';
import React, { Component } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { IssuePage } from '../../content/issuePage/IssuePage';
import { IssueType } from '../../../@types/issueType';
import { getLogger } from '../../../utils/logger/logger';

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<PropsWithChildren, State> {
  public state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(_: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const renderingError = new Error(error.message);
    renderingError.name = `ReactRenderingError`;
    renderingError.stack = errorInfo.componentStack;
    renderingError.cause = error;
    datadogRum.addError(renderingError);
    getLogger('ErrorBoundary').error({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) return <IssuePage type={IssueType.UNKNOWN} />;

    return this.props.children;
  }
}
